/* import __COLOCATED_TEMPLATE__ from './assignee-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();